import { Button } from "../Buttons";
import Card from "../Card";
import CreditScoreChart from "../CreditScoreChart";

const CreditScore = () => {
  return (
    <Card className="flex-1">
      <div className="flexCol justify-center">
        <p className="font-filson-soft font-[700] text-[16px] text-center text-[#424952] leading-[19.84px] tracking-[-0.02em]">
          Your Credit Score
        </p>
        <div className="flex flex-col justify-center items-center mt-[18px]">
          <div className="w-[216px] ">
            <CreditScoreChart value={760} max={900} progressStroke="#00C08B" />
          </div>
          <p className="font-[500] text-[#424952] text-opacity-[70%]">
            Last Updated - 30/3/2023
          </p>
        </div>
        <Button
          containerStyle="flex justify-center"
          title="Update"
          variant="tertiary"
          className="mt-[20px] boxShadow"
        />
      </div>
    </Card>
  )
}
export default CreditScore;
